import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@instructure/ui-view';
// eslint-disable-next-line no-restricted-imports -- We don't use `SettingsSwitcher` in the main app
import { SimpleSelect } from '@instructure/ui-simple-select';
import canvasTheme from '@instructure/canvas-theme';
import highContrastTheme from '@instructure/canvas-high-contrast-theme';
import { InstUISettingsProvider } from '@instructure/emotion';
import { ApplyLocale } from '../index';
import { LocaleSelect } from './LocaleSelect';
var themes = [{
  name: 'canvas',
  type: canvasTheme
}, {
  name: 'canvas-high-contrast',
  type: highContrastTheme
}];

// This is for switching locale/theme in the docs app. Not for production use!
// TODO: Add support for changing timezones!
export var SettingsSwitcher = /*#__PURE__*/function (_Component) {
  function SettingsSwitcher() {
    var _this2;
    _classCallCheck(this, SettingsSwitcher);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, SettingsSwitcher, [].concat(args));
    _defineProperty(_this2, "state", {
      loading: false,
      locale: 'en',
      translations: null,
      theme: themes[0].name
    });
    _defineProperty(_this2, "handleLocaleChange", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, _ref) {
        var locale;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              locale = _ref.value;
              _this2.setState({
                loading: true
              });
              _context.prev = 2;
              _context.next = 5;
              return _this2.loadTranslations(locale);
            case 5:
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
              console.error('Failed to update locale', _context.t0);
            case 10:
              _context.prev = 10;
              _this2.setState({
                loading: false
              });
              return _context.finish(10);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 7, 10, 13]]);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this2, "handleThemeChange", function (event, _ref3) {
      var theme = _ref3.value;
      _this2.setState({
        theme: theme
      });
    });
    return _this2;
  }
  _inherits(SettingsSwitcher, _Component);
  return _createClass(SettingsSwitcher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadTranslations(this.state.locale);
    }
  }, {
    key: "loadTranslations",
    value: function () {
      var _loadTranslations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(locale) {
        var translations;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return import('@instructure/quiz-translations/lib/' + locale + '.json');
            case 2:
              translations = _context2.sent;
              this.setState({
                locale: locale,
                translations: translations
              });
              _context2.next = 6;
              return this.props.onLocaleChange(locale, translations);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadTranslations(_x3) {
        return _loadTranslations.apply(this, arguments);
      }
      return loadTranslations;
    }() // Split select component out
    // Remove fetching logic from ApplyLocale
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var selectOptionIdPrefix = 'settings-switcher-select-option-';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(View, {
        margin: "0 small small 0",
        display: "inline-block"
      }, /*#__PURE__*/React.createElement(LocaleSelect, {
        value: this.state.locale,
        interaction: this.state.loading ? 'disabled' : 'enabled',
        onChange: this.handleLocaleChange,
        locales: this.props.locales
      })), /*#__PURE__*/React.createElement(View, {
        margin: "0 small small 0",
        display: "inline-block"
      }, /*#__PURE__*/React.createElement(SimpleSelect, {
        renderLabel: "Theme",
        width: "12rem",
        value: this.state.theme,
        onChange: this.handleThemeChange
      }, themes.map(function (theme) {
        return /*#__PURE__*/React.createElement(SimpleSelect.Option, {
          id: selectOptionIdPrefix + theme.name,
          key: theme.name,
          value: theme.name
        }, theme.name);
      }))), /*#__PURE__*/React.createElement(View, {
        as: "div",
        background: "primary"
      }, /*#__PURE__*/React.createElement(InstUISettingsProvider, {
        theme: themes.find(function (theme) {
          return theme.name === _this3.state.theme;
        }).type
      }, /*#__PURE__*/React.createElement(ApplyLocale, {
        locale: this.state.locale,
        translations: this.state.translations,
        forceDeepRender: true
      }, this.props.children))));
    }
  }]);
}(Component);
_defineProperty(SettingsSwitcher, "propTypes", {
  locales: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  onLocaleChange: PropTypes.func
});
_defineProperty(SettingsSwitcher, "defaultProps", {
  locales: ['en'],
  onLocaleChange: Function.prototype
});
export default SettingsSwitcher;